module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Cooking/Knife&fork#1-6ddb5e2c03d021f525eb6b38fcf314f4.svg";